import {Row} from "@tanstack/react-table";
import {Ticket} from "Stores/dashboardStore/tickets";
import {Utils} from "./utils";

export const isWithinRangeFilter = (row, columnId, value) => {
    const date = new Date(row.getValue(columnId))
    const [start, end] = value;

    if((start || end) && !date) return false;
    if(start && !end){
        return date.getTime() >= start.getTime();
    }else if(!start && end){
        return date.getTime() <= end.getTime();
    }else if (start && end) {
        return date.getTime() >= start.getTime() && date.getTime() <= end.getTime();
    } else {return true;}
};


export const isCommitteeProtectedFilter = (row, columnId, value: string) => {
    const rowValue = row.getValue(columnId) as boolean;
    if (value === "all") {
        return true;
    } else if (value === "yes") {
        return rowValue;
    } else {
        return !rowValue;
    }
};

export const isLabelActiveFilter = (row, columnId, value: string) => {
    const rowValue = row.getValue(columnId) as boolean;
    if (value === "all") {
        return true;
    } else if (value === "active") {
        return !rowValue;
    } else {
        return !!rowValue;
    }
};

export const isIngestibleFilter = (row, columnId, value: string) => {
    const rowValue = row.getValue(columnId) as boolean;
    if (value === "any") {
        return true;
    } else if (value === "yes") {
        return rowValue;
    } else {
        return !rowValue;
    }
};

export const isYesNoAnyFilter = (row, columnId, value: string) => {
    const rowValue = row.getValue(columnId) as boolean;
    if (value === "any") {
        return true;
    } else if (value === "yes") {
        return rowValue;
    } else {
        return !rowValue;
    }
};

export const isActiveInactiveFilter = (row, columnId, value: string) => {
    const rowValue = (row.getValue(columnId) as string).toLowerCase();

    if (value === "all") {
        return true;
    } else if (value === "active") {
        return rowValue === "active";
    } else if (value === "inactive") {
        return rowValue === "inactive";
    }
    return rowValue !== "active" && rowValue !== "inactive";
};

export const isUserStatusFilter = (row, columnId, value: string) => {
    const rowValue = row.getValue(columnId) as string;
    if (value === "any") {
        return true;
    }

    return rowValue === value;
};

export const hasMenteesFilter = (row, columnId, value: string) => {
    const rowValue = row.getValue(columnId) as number;
    if (value === "no_mentees") {
        return rowValue <= 0;
    }

    if (value === "has_mentees") {
        return rowValue > 0;
    }

    return true;
};

export const hasCoursesFilter = (row, columnId, value: string) => {
    const rowValue = row.getValue(columnId) as number;
    if (value === "no_courses") {
        return rowValue <= 0;
    }

    if (value === "has_courses") {
        return rowValue > 0;
    }

    return true;
};

export const hasCommitteesFilter = (row, columnId, value: string) => {
    const rowValue = row.getValue(columnId) as number;
    if (value === "not_on_committee") {
        return rowValue <= 0;
    }

    if (value === "on_committee") {
        return rowValue > 0;
    }

    return true;
};

export const isColumnNumberFilter = (row, columnId, value: string) => {
    const rowValue = row.getValue(columnId) as number;
    return rowValue.toString().startsWith(value);
};

export const isActionPlanStatusFilter = (row: Row<Ticket>, columnId, filter: string) => {
    const rowValue = row.getValue(columnId) as string;
    const targetMet = row.original.target_met as boolean;
    if ( filter === "goal-met") {
        return rowValue === "closed" && targetMet;
    } else if (filter === "goal-not-met") {
        return rowValue === "closed" && !targetMet;
    } else if (filter === "open") {
        return rowValue === "open";
    }
    return true;
};

export const isActionPlanCreatedFilter = (row: Row<Ticket>, columnId: string, filter: string) => {
    const date = new Date();
    if (filter === "all") {
        return true;
    } else if (filter === "last_month") {
        filter = new Date(date.setMonth(date.getMonth() - 1)).toString();
    } else if (filter === "last_3_months") {
        filter = new Date(date.setMonth(date.getMonth() - 3)).toString();
    } else if (filter === "last_6_months") {
        filter = new Date(date.setMonth(date.getMonth() - 6)).toString();
    } else if (filter === "last_9_months") {
        filter = new Date(date.setMonth(date.getMonth() - 9)).toString();
    } else if (filter === "last_12_months") {
        filter = new Date(date.setMonth(date.getMonth() - 12)).toString();
    }
    const rowValue = row.getValue(columnId) as string;

    const filterDate = new Date(filter);
    const createdDate = new Date(Utils.getValidDateFromString(rowValue).valueOf());
    return createdDate >= filterDate;
};

export const isActionPlanDueDateFilter = (row: Row<Ticket>, columnId: string, filter: string) => {
    const date = new Date();
    if (filter === "all") {
        return true;
    } else if (filter === "next_month") {
        filter = new Date(date.setMonth(date.getMonth() + 1)).toString();
    } else if (filter === "three_month") {
        filter = new Date(date.setMonth(date.getMonth() + 3)).toString();
    } else if (filter === "next_6_months") {
        filter = new Date(date.setMonth(date.getMonth() + 6)).toString();
    } else if (filter === "next_9_months") {
        filter = new Date(date.setMonth(date.getMonth() + 9)).toString();
    } else if (filter === "next_12_months") {
        filter = new Date(date.setMonth(date.getMonth() + 12)).toString();
    }
    const rowValue = row.getValue(columnId) as string;
    const filterDate = new Date(filter);
    const dueDate = new Date(Utils.getValidDateFromString(rowValue).valueOf());
    return dueDate >= new Date() && dueDate <= filterDate;
};
